import landing from './landing'
import footer from './footer'
import silver from './products/silver'
import gold from './products/gold'
import coin from './products/coin'
import credit from './products/credit'
import validator from './products/validator'
import key from './products/key'
import uranium from './products/uranium'

const products = {
  silver,
  gold,
  coin,
  credit,
  validator,
  key,
  uranium,
}

export {
  landing,
  footer,
  products
}
